module.exports = __webpack_public_path__ + "static/2-fa7605ca032e2d49d042daec07af7b71.jpg";